import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AttendanceMatrix from "../../components/Common/AttendanceMatrix";
import { handleAuthError } from "../../utils";
import { baseUrl } from "../../Network";
import withAuth from "../withAuth";

const asArray = (data) => (Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : []);

// Attendance Report: every student's attendance in a cohort, as marked by teachers.
const ManageAttendance = () => {
  document.title = "Attendance Report | RYD Admin";
  const [cohorts, setCohorts] = useState([]);
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [cohortRes, teacherRes] = await Promise.all([
          axios.get(`${baseUrl}/admin/cohort/all`, { params: { limit: 10000 } }),
          axios.get(`${baseUrl}/admin/teacher/all`, { params: { limit: 10000 } }),
        ]);
        setCohorts(asArray(cohortRes.data?.data));
        setTeachers(asArray(teacherRes.data?.data));
      } catch (error) {
        handleAuthError(error);
        console.error("Error loading attendance filters:", error);
      }
    })();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Attendance Report" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h5 className="card-title mb-1">Attendance Report</h5>
                  <p className="text-muted small mb-4">
                    Each paid student in one selected cohort, with that student's present, absent, rescheduled present, and rescheduled absent totals. The older attendance marks stay available separately and are not copied into this report.
                  </p>
                  <AttendanceMatrix
                    reportUrl={`${baseUrl}/admin/attendance/cohort`}
                    cohorts={cohorts}
                    teachers={teachers}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withAuth(ManageAttendance);
